export const toContactOptions = (contacts)=>contacts.map((contact)=>({
            id: contact.id(),
            label: "".concat(contact.fullName(), " (").concat(contact.email(), ")")
        }));
export const findContactOption = (options, value)=>{
    var _options_find;
    return value == null ? null : (_options_find = options.find((option)=>option.id === value.id())) !== null && _options_find !== void 0 ? _options_find : null;
};
